import { favoritesApi } from '../../redux/services/favoritesApi'
import { LoaderTopMovie } from '../../ui/LoaderTopMovie/LoaderTopMovie'
import { FavoriteMovie } from '../FavoriteMovie/FavoriteMovie'
import './FavoritesMovies.scss'

export const FavoritesMovies = () => {

    const { data: favoritesMovies, isLoading, error, refetch } = favoritesApi.useGetFavoritesQuery(`/favorites`)

    return (
        <section className='favorites-movies'>
            <div className="favorites-movies__container">
                <div className="favorites-movies__wrap">
                    {isLoading && <LoaderTopMovie />}
                    {error &&
                        <div>
                            <h2 style={{ marginBottom: "10px" }}> Произошла ошибка</h2> <button className='btn btn-dark' onClick={() => refetch()}>Обновить список</button>
                        </div>}
                    <ul className='favorites-movies__list'>
                        {favoritesMovies && favoritesMovies.map((favoriteMovie) =>
                            <li className='favorites-movies__item' key={favoriteMovie.id}>
                                <FavoriteMovie favoriteMovie={favoriteMovie} />
                            </li>

                        )}
                    </ul>
                </div>

            </div>
        </section>
    )
}